type PropsType = {
  fill?: string;
};

const CashPaymentIcon = ({ fill }: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.975 5.53359C15.6167 3.72526 14.2751 2.93359 12.4084 2.93359H5.09172C2.89172 2.93359 1.42505 4.03359 1.42505 6.60026V10.8919C1.42505 12.7419 2.18338 13.8253 3.43338 14.2919C3.61672 14.3586 3.81672 14.4169 4.02505 14.4503C4.35838 14.5253 4.71672 14.5586 5.09172 14.5586H12.4167C14.6167 14.5586 16.0834 13.4586 16.0834 10.8919V6.60026C16.0834 6.20859 16.05 5.85859 15.975 5.53359ZM4.60838 10.0003C4.60838 10.3419 4.32505 10.6253 3.98338 10.6253C3.64172 10.6253 3.35838 10.3419 3.35838 10.0003V7.50026C3.35838 7.15859 3.64172 6.87526 3.98338 6.87526C4.32505 6.87526 4.60838 7.15859 4.60838 7.50026V10.0003ZM8.75005 10.9503C7.53338 10.9503 6.55005 9.96693 6.55005 8.75026C6.55005 7.53359 7.53338 6.55026 8.75005 6.55026C9.96672 6.55026 10.95 7.53359 10.95 8.75026C10.95 9.96693 9.96672 10.9503 8.75005 10.9503ZM14.1334 10.0003C14.1334 10.3419 13.85 10.6253 13.5084 10.6253C13.1667 10.6253 12.8834 10.3419 12.8834 10.0003V7.50026C12.8834 7.15859 13.1667 6.87526 13.5084 6.87526C13.85 6.87526 14.1334 7.15859 14.1334 7.50026V10.0003Z"
        fill={fill ?? '#015C9A'}
      />
      <path
        d="M18.5834 9.09958V13.3912C18.5834 15.9579 17.1167 17.0662 14.9084 17.0662H7.59172C6.96672 17.0662 6.40838 16.9746 5.92505 16.7912C5.53338 16.6496 5.19172 16.4412 4.91672 16.1746C4.76672 16.0329 4.88338 15.8079 5.09172 15.8079H12.4084C15.4917 15.8079 17.3251 13.9746 17.3251 10.8996V6.59958C17.3251 6.39958 17.5501 6.27458 17.6917 6.42458C18.2584 7.02458 18.5834 7.89958 18.5834 9.09958Z"
        fill={fill ?? '#015C9A'}
      />
    </svg>
  );
};

export default CashPaymentIcon;
